export default "__VITE_ASSET__01758e21__"